export default __webpack_public_path__ + "static/images/referral-page-facebook-8437ba0cf481b654d0ffbdf29d4eee2f.jpg";